import * as React              from 'react'
import PropTypes               from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'
import "./style.scss"

class TabsComponent extends React.Component {

	render() {
		const selected = this.props.selected

		return (
			<div className="tabs-container">
				<nav className="tabs">
					<ul>
						{React.Children.map(this.props.children, (child, index) => {
							const isSelected = selected === index
							return (
								<li key={index} className={isSelected ? "is-active" : ""}>
									<NavLink
									aria-current={isSelected ? "true" : null}
									className={isSelected ? 'active' : ''}
									onClick={this.props.onTabClick.bind(this, index)}
									to={'#' + child.props.id}>
										{child.props.icon &&
											<span className="icon is-small">
												<i className={`fas fa-${child.props.icon.name}`} color={child.props.icon.color || null} />
											</span>}
										<span>{child.props.title}</span>
									</NavLink>
								</li>)
						})}
					</ul>
				</nav>
				<div className="panes">
					{React.Children.map(this.props.children, (child, index) => {
						const active = index === selected
						return active ? React.cloneElement(child, { active }) : null
					})}
				</div>
			</div>
		)
	}
}

TabsComponent.propTypes = {
	singled: PropTypes.bool
}

export default withRouter(TabsComponent)


// WEBPACK FOOTER //
// ./src/component/tabs/tabs-component.js